var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.775 1.23432C12.4175 0.876823 11.84 0.876823 11.4825 1.23432L7.00003 5.70766L2.51753 1.22516C2.16003 0.867656 1.58253 0.867656 1.22503 1.22516C0.867534 1.58266 0.867534 2.16016 1.22503 2.51766L5.70753 7.00016L1.22503 11.4827C0.867534 11.8402 0.867534 12.4177 1.22503 12.7752C1.58253 13.1327 2.16003 13.1327 2.51753 12.7752L7.00003 8.29266L11.4825 12.7752C11.84 13.1327 12.4175 13.1327 12.775 12.7752C13.1325 12.4177 13.1325 11.8402 12.775 11.4827L8.29253 7.00016L12.775 2.51766C13.1234 2.16932 13.1234 1.58266 12.775 1.23432Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackClear);
export default __webpack_public_path__ + "static/media/blackClear.a406d4c695f4cc489dcf0a8dd633ffa1.svg";
export { ForwardRef as ReactComponent };